import formatDate from "../../../helpers/formatDate.ts";
import { concat, join, map } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import useTooltip from "../../../hooks/useTooltip.tsx";
import { Activity } from "../../../@types/activities.ts";

type EmailRecommendedIndicatorArgs = {
  lastRecommendation?: Activity["email_recommendation"];
  emailRecommendedTo?: Activity["email_recommended_to"];
  emailRecommendedToMembers?: Activity["email_recommended_to_members"];
  externalEmailRecommendedTo?: Activity["external_email_recommended_to"];
};
export default function EmailRecommendedIndicator({
  lastRecommendation,
  emailRecommendedTo,
  emailRecommendedToMembers,
  externalEmailRecommendedTo,
}: EmailRecommendedIndicatorArgs) {
  const tooltipRef = useTooltip<HTMLDivElement>();

  return (
    <div
      ref={tooltipRef}
      className="btn btn-sm text-muted"
      title={I18n.t("js.activitystreams.email_recommended_to.tooltip", {
        date:
          lastRecommendation &&
          formatDate(new Date(lastRecommendation.created_at), "PPPP, HH:mm"),
        activitystream_names_csv: join(
          concat(
            map(emailRecommendedTo, "name"),
            map(emailRecommendedToMembers, "name"),
            externalEmailRecommendedTo,
          ),
          ", ",
        ),
      })}
    >
      <FontAwesomeIcon icon={faEnvelope} />
    </div>
  );
}
